// src\@vxapp\constants.js

export const API_URL = import.meta.env.VITE_API_URL
export const API_TIMEOUT = import.meta.env.VITE_API_TIMEOUT

export const VXAPP_BRANDING = 'vxapp'
export const VXAPP_VERSION = '0.4.0'

// PayPal Credentials
export const DEVELOPMENT_MODE = import.meta.env.VITE_DEVELOPMENT_MODE === 'true'



export const PAYPAL_SANDBOX_CLIENT_ID =
  'AW5dLXC0JjS6ldffXJvvIIlFXvwnr-g4Vqg61gFpl8aX-P14iBGTrQGB62pn-ecVvvz2XAnXbmxq76DO'

const PAYPAL_SANDBOX_SDK_URL =
  'https://www.paypal.com/sdk/js?client-id=' + PAYPAL_SANDBOX_CLIENT_ID + '&currency=AUD'

export const PAYPAL_LIVE_CLIENT_ID =
  'Ab-S2VX_eFKlf9ck2BFDVe-VXbp0UfNw9EhKoxelb68WDEfRb5j12PjSeyGPNNFXCAeavxEwsI08gGxH'

const PAYPAL_LIVE_SDK_URL =
  'https://www.paypal.com/sdk/js?client-id=' + PAYPAL_LIVE_CLIENT_ID + '&currency=AUD'

export const PAYPAL_SDK_URL = DEVELOPMENT_MODE ? PAYPAL_SANDBOX_SDK_URL : PAYPAL_LIVE_SDK_URL
